import {
  createContext,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM, WEB_IN_APP_ID } from 'shared/constants/common';

type WebInAppContextActions = {
  isWebInApp: boolean;
  webInAppId: WEB_IN_APP_ID | null;
};

const WebInAppContext = createContext({} as WebInAppContextActions);

interface WebInAppContextProviderProps {
  children: ReactNode;
}

const WebInAppProvider: FC<WebInAppContextProviderProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const webInAppId = searchParams.get(SEARCH_PARAM.WEB_IN_APP);

  const [isWebInApp, setIsWebInApp] = useState<boolean>(false);

  useEffect(() => {
    setIsWebInApp(!!webInAppId);
  }, [webInAppId]);

  return (
    <WebInAppContext.Provider
      value={{
        webInAppId: !!webInAppId ? (webInAppId as WEB_IN_APP_ID) : null,
        isWebInApp,
      }}
    >
      {children}
    </WebInAppContext.Provider>
  );
};

const useWebInApp = (): WebInAppContextActions => {
  const context = useContext(WebInAppContext);

  if (!context) {
    throw new Error('useWebInApp must be used within an WebInAppProvider');
  }

  return context;
};

export { WebInAppProvider, useWebInApp };
